/* Guarded because this file is included per section instance and by more than
   one section, so it can execute several times on a page. The classes live
   inside the block, which keeps them block-scoped and makes a second run a
   no-op instead of an "already declared" SyntaxError. */
if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.viewAllLinks = Array.from(this.querySelectorAll('[data-view-all]'));

      // DragScroll comes from drag-scroll.js, loaded ahead of this file by the section.
      if (window.DragScroll) {
        this.querySelectorAll('.slider').forEach((slider) => new window.DragScroll(slider));
      }

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (event) => this.onKeyDown(event, tab));

        // In the theme editor, activate the tab when its block is selected.
        if (window.Shopify?.designMode) {
          tab.addEventListener('shopify:block:select', () => this.select(tab));
        }
      });

      // Point the "View all" links at the initially active tab's collection.
      const active = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      if (active) this.syncViewAll(active);
    }

    select(tab) {
      this.tabs.forEach((current) => {
        const selected = current === tab;
        current.setAttribute('aria-selected', selected ? 'true' : 'false');
        current.setAttribute('tabindex', selected ? '0' : '-1');
        current.classList.toggle('collection-tabs__tab--active', selected);
      });

      const controls = tab.getAttribute('aria-controls');
      this.panels.forEach((panel) => {
        const show = panel.id === controls;
        panel.hidden = !show;
        panel.classList.toggle('hidden', !show);
      });

      this.syncViewAll(tab);
    }

    syncViewAll(tab) {
      const url = tab.dataset.collectionUrl;
      this.viewAllLinks.forEach((link) => {
        if (url) {
          link.href = url;
          link.hidden = false;
        } else {
          // No collection assigned to this tab — hide the link rather than linking nowhere.
          link.hidden = true;
        }
      });
    }

    onKeyDown(event, tab) {
      const keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
      const direction = keys[event.key];
      if (!direction) return;

      event.preventDefault();
      const index = this.tabs.indexOf(tab);
      const next = this.tabs[(index + direction + this.tabs.length) % this.tabs.length];
      this.select(next);
      next.focus();
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
